module.exports = __webpack_public_path__ + "img/05.894c0380.png";